import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-delete",
  "use": "n-icon-delete-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"n-icon-delete\">\n  <symbol id=\"n-icon-delete_delete\" viewBox=\"0 0 8 8\">\n    <path d=\"M.16.16a.543.543 0 0 0 0 .767L3.231 4 .159 7.073a.543.543 0 0 0 .768.768L4 4.768l3.073 3.073a.543.543 0 1 0 .768-.768L4.768 4 7.841.927A.543.543 0 1 0 7.073.16L4 3.232.927.159a.543.543 0 0 0-.768 0Z\" fill=\"currentColor\" />\n  </symbol>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol